module.exports = __webpack_public_path__ + "static/policeway-de54960c9a76351c8eab63fd7db87980.jpg";